import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { DictionaryService } from '@cawita/core-front';
import { CWT_CUSTOM_ERROR_HANDLER_HEADER } from '@cawita/core-front/api';
import { ToastService } from '@mobile/services/commons/toast.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private injector: Injector,
        private dictionary: DictionaryService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const toast = this.injector.get(ToastService);
        if (!req.headers.has(CWT_CUSTOM_ERROR_HANDLER_HEADER.toLowerCase())) {
            return next.handle(req).pipe(catchError((e: HttpErrorResponse) => {
                if (e.status === 0) {
                    toast.error('notification.connection-lost');
                } else if (e.error.errorId === 'duplicateKey' && e.error.field === 'login') {
                    toast.error('notification.login-already-used');
                } else {
                    toast.error(this.dictionary.translate(e?.error?.translations, 'notification.error-occured'));
                }
                throw e;
            }));
        }

        return next.handle(req.clone({
            headers: req.headers.delete(CWT_CUSTOM_ERROR_HANDLER_HEADER.toLowerCase())
        }));
    }
}
